'use client';
import styled from 'styled-components';
import { devices, theme } from 'styles/theme';
import ReactHtmlParser from 'react-html-parser';
import reactHtmlParser from 'react-html-parser';
import { Img } from '@/src/components/common/ui/images/Img';

const IndustrySingle = ({title, img, description, version, accordion}) => {
	return (
		<StyledIndustrySingle className={`Industry-single ${version ? 'version' : accordion ? 'accordion' : ''} `}>
			<div className="Industry-single__inner">
				<Img src={img} objectFit={'cover'} alt={ReactHtmlParser(title)} layout={'fill'} />

			</div>
			<div className="Industry-single__inner__content">
				{
					title &&
					<h6>{reactHtmlParser(title)}</h6>

				}
				{
					description &&
					reactHtmlParser(description)
				}
			</div>
		</StyledIndustrySingle>
	);
};

const StyledIndustrySingle = styled.div`
    overflow: hidden;
    position: relative;
    height: 100%;
    cursor: pointer;

    &.accordion {
        padding: 0;
    }
    a {
        height: 100%;
        width: 100%;
        ${theme.absoluteFill}
        z-index: 3;
    }

    .Industry-single__inner {
        padding-top: ${theme.indusTryRatio};
        position: relative;
        overflow: hidden;
        cursor: pointer;
        z-index: 0;

        .global-image {
            transition: ${theme.transition};
            transform: scale(1.01);
            overflow: hidden;
        }
        &__content {
            display: flex;
            flex-direction: column;
            padding: 30px;
            background: ${theme.colors.secondaryGreen};
            z-index: 2;
            position: relative;
            overflow: hidden;
            height: 100%;
            @media (max-width: 992px) {
                padding: 25px;
            }

            p {
                ${theme.mainFont}
                color: ${theme.colors.white};
                transition: ${theme.transition};

                strong {
                    font-weight: 500;
                }
            }

            h6 {
                color: ${theme.colors.white};
                ${theme.mainTitle}
                display: flex;
                transition: ${theme.transition};
                transition-delay: 0.3s;
                margin-bottom: 15px;

            }
        }
    }


    &.version {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        height: auto;
        background: ${theme.colors.secondaryGreen};
        overflow: hidden;
		@media(min-width: 1500px){
            margin-top: -15px;
		}
        ${devices.ResponsiveTabMobile} {
            height: 100%;
        }
        .Industry-single__inner {
            flex: 0 0 40%;
            width: 40%;
            padding-top: 20%;
            height: 100%;
        }
        .Industry-single__inner__content {
            flex: 0 0 60%;
            width: 60%;
            padding: 50px 70px;
            height: 100%;
            @media (max-width: 992px) {
                padding: 25px;
            }
        }
    }


`;
export default IndustrySingle;
